import React from 'react';
import Axios from 'axios';
import moment from 'moment';
import { withRouter } from "../../withRouter"; 	// HOC pour React Router v6
import { ConnectedUserContext } from '../../connectedUser-context';

import SeasonScheduledMatchModal from './SeasonScheduledMatchModal';
import * as myConstClass from '../../shared/constants/constants';


// not used
const cstTableHeaders = ['', 'Cédulé', 'Joué', '#', 'Sous-saison', 'Programme', 'Location', 'Map', 
	'Équipe A', 'Équipe B', 'Format', 'Validation', ''];

const cstDefaultSortOrder = ['asc', 'asc', 'asc', 'asc', 'asc', 'asc', 'asc', 'asc', 'asc', 'asc', 'asc', 'asc'];
const cstDefaultSortFieldIdx = 1;

const cstGoogleMapColIdx = 6;
const cstValidStatusColIdx = 10;
const TABLE_NBCOL = 10;

const cstSsValidationTranslation = myConstClass.SS_VALIDATION_TRANSLATION;


class SeasonSchedule extends React.Component {

	static contextType = ConnectedUserContext;

  constructor(props) {
		super(props);

		this.state = {
			scheduleData: [],
			ssIdxNext: -1,

      sortParams: {
				sortFieldIdx: cstDefaultSortFieldIdx,
				sortOrder: cstDefaultSortOrder[cstDefaultSortFieldIdx],
				sortClass: []
			},

			modalScheduledMatch: {
				_id: '0',
				dateScheduled: null,
				datePlayed: null,
				ssIdx: -1,
				week: 1,
				seasonId: this.props.season._id,
				locationId: '0',
				subSeasonId: '0',
				team1Id: '0',
				team2Id: '0',
				validation: { 
					teamA: {edited: false, validated: false},
					teamB: {edited: false, validated: false},
					validationStatusTxt: "None" 
				},
				scoresheetFormatId: '0',
				handicapType: null,
				handicapMax: null
			},

			// Scheduled matches map
			scheduledMatchesMap: {},   // clé = sm._id, valeur = l'objet sm complet

			showSeasonScheduledMatchModal: false,
			loading: true,
		};

    this.handleSortTable = this.handleSortTable.bind(this);
    this.handleModalCancel = this.handleModalCancel.bind(this);
		this.createTableRow = this.createTableRow.bind(this);
		this.createDataCell = this.createDataCell.bind(this);
    this.reloadData = this.reloadData.bind(this);
	}

	componentDidMount() {
		// console.log('SeasonSchedule: componentDidMount');
		if (this.props.season._id != undefined) {
			this.loadData(true);
		}
	}

  componentDidUpdate(prevProps) {
  	//console.log('SeasonSchedule: componentDidUpdate')
  	//console.log(this.props)
  	if (!this.props.bEnableSheduledPrograms) {
  		const path = './';
			this.props.navigate(path);
		} else if (this.props.season._id !== prevProps.season._id) {
			this.loadData(true);
	  }
  }

	loadData(resetSorting) {
		var _this = this;
		Axios.get('/api/scoresheets2/seasonId/' + _this.props.season._id).then(function(response) {
			// console.log('response.data');
			// console.log(response.data);
			var scheduledMatchs = response.data.matchs;
			var ssIdxNext = response.data.ssIdxNext;

			// build data
			_this.setState({
				ssIdxNext: ssIdxNext
			}, _this.buildScheduledMatchsTable(scheduledMatchs, resetSorting)
			)
		});	

	}

	buildScheduledMatchsTable(scheduledMatchs, resetSorting) {
		var scheduleData = [];
  	var scheduledMatchesMap = {};

		scheduledMatchs.forEach((sm, smIdx) => {
			var scheduledMatchsRow = [];

			let dateScheduled = sm.dateScheduled ? moment(sm.dateScheduled).local().format("YYYY-MM-DD") : '';
			let datePlayed = sm.datePlayed ? moment(sm.datePlayed).local().format("YYYY-MM-DD") : '';

			let handicapTxt = "";
			if (sm.handicapType) {

				const handicapTypeMap = {
				  [myConstClass.HANDICAPTYPE.MOY]: "MOY",
				  [myConstClass.HANDICAPTYPE.TRS]: "TRS",
				  [myConstClass.HANDICAPTYPE.SCAB]: "SCAB"
				};
				const typeLabel = handicapTypeMap[sm.handicapType] ?? sm.handicapType;

			  if (sm.handicapMax != null) {
			    handicapTxt = ` (${typeLabel} ${sm.handicapMax})`;
			  } else {
			    handicapTxt = ` (${typeLabel})`;
			  }
			}

			scheduledMatchsRow.push(dateScheduled);
			scheduledMatchsRow.push(datePlayed);
			scheduledMatchsRow.push(sm.ssIdx);
			scheduledMatchsRow.push(sm.subSeasonName);
			scheduledMatchsRow.push(sm.week);
			scheduledMatchsRow.push(sm.locationName);
			scheduledMatchsRow.push(sm.locationGooglemap);
			scheduledMatchsRow.push(sm.team1Name);
			scheduledMatchsRow.push(sm.team2Name);
			scheduledMatchsRow.push(sm.ssFormatTag + handicapTxt);
			scheduledMatchsRow.push(sm.validation.validationStatusTxt);

			scheduledMatchsRow._id = sm._id;
			scheduleData.push(scheduledMatchsRow);

			// Scheduled matches map
	    scheduledMatchesMap[sm._id] = sm;
		});

		var sortParams = this.state.sortParams;

		if (resetSorting)	{
			sortParams = {
				sortFieldIdx: cstDefaultSortFieldIdx,
				sortOrder: cstDefaultSortOrder[cstDefaultSortFieldIdx],
				sortClass: []
			};
		};

		this.sortscheduleData(scheduleData, sortParams, scheduledMatchesMap);
	}

	sortscheduleData(scheduleData, sortParams, scheduledMatchesMap) {
			var _this = this;
		if (scheduleData.length !== 0) {

			var sortSign = 1;
			if (sortParams.sortOrder === 'desc') { 
				sortSign = -1; 
			}

			scheduleData.sort(function(a, b) {

				var valueA = 0;
				var valueB = 0;
				var compVal = 0;
				var fact1 = 0;
				var defFact = 0;

				// Criteria #1
				valueA = a[sortParams.sortFieldIdx];
				valueB = b[sortParams.sortFieldIdx];

				switch (typeof valueA) {
			    case "date":
						compVal = new Date(valueA) - new Date(valueB);
						break;
			    case "string":
			    	// test if string is numeric
			    	if (_this.isNumeric(valueA) && _this.isNumeric(valueB)) {
							compVal = parseInt(valueA, 10) - parseInt(valueB, 10);
			    	} else {
							compVal = valueA.localeCompare(valueB);
						}
						break;
			    case "number":
						compVal = valueA - valueB;
						break;
			    default:
						compVal = 0;
						break;
				}

				fact1 = (sortSign * compVal);
				defFact = a[0].localeCompare(b[0]);

				// Results
				if (fact1 !== 0) {
					return fact1;
				} else {
					return defFact;
				}
			});
		}

		this.setState({
			scheduleData: scheduleData,
			sortParams: sortParams,
    	scheduledMatchesMap: scheduledMatchesMap || this.state.scheduledMatchesMap,
			loading: false
		});
	}

	reloadData() {
		this.loadData(false);
	}

	render() {
		// console.log('SeasonSchedule: RENDER');
		// console.log(this.state.scheduleData)
		const { connectedUser } = this.context;

		// ADMIN LEVEL REQUESTED:  00-MASTER
		if (connectedUser.isMasterAdmin) {
			return (
				<div>

				<div className="row">
        <div className="col-12">
        	<h5>MATCHS CÉDULÉS</h5>
				</div>
				</div>

				{(this.state.loading) ?
					this.displaySpinner() : 
					this.displayData()
				}

				<br/><br/><br/>

				{/* Modal */}
				<SeasonScheduledMatchModal 
					className = {this.props.className}
					showModal = {this.state.showSeasonScheduledMatchModal}
					modalScheduledMatch = {this.state.modalScheduledMatch}
					season = {this.props.season}
					handleModalCancel = {this.handleModalCancel}
					reloadData = {this.reloadData}
				/>

				</div>
			);

		} else {
			return (
				<div className="col-md-9">
					<p>Vous n'avez pas accès à cette section</p>
				</div>
			);
		}
	}

	displayData() {
		var sortClass = this.state.sortParams.sortClass;

		return (
			<div>

			<div className="row">
      <div className="col-12">
      	<p></p>
			</div>
			</div>

			<div className="row">
			<div className="col-12">
			<button className="btn btn-sm btn-primary btn-margin-topbottom-10 btn-extra-padding" 
				onClick={this.handleAddEditScheduledMatchClick.bind(this, "NEW SM")}>
				Nouveau match
			</button>
			</div>
			</div>

			<div className="table-responsive">
			<table className="table table-hover table-sm">
			<thead>
				<tr>
					<th></th>
					<th id='hdr.0' className={"statelo-sorting " + sortClass[0]} onClick={this.handleSortTable} > Cédulé </th>
					<th id='hdr.1' className={"statelo-sorting " + sortClass[1]} onClick={this.handleSortTable} > Joué </th>
					<th id='hdr.2' className={"statelo-sorting " + sortClass[2]} onClick={this.handleSortTable} > #	</th>
					<th id='hdr.3' className={"statelo-sorting " + sortClass[3]} onClick={this.handleSortTable} > Sous-saison	</th>
					<th id='hdr.4' className={"statelo-sorting " + sortClass[4]} onClick={this.handleSortTable} > Prog.	</th>
					<th id='hdr.5' className={"statelo-sorting " + sortClass[5]} onClick={this.handleSortTable} > Lieu </th>
					<th id='hdr.6' > Map </th>
					<th id='hdr.7' className={"statelo-sorting " + sortClass[6]} onClick={this.handleSortTable} > Équipe A </th>
					<th id='hdr.8' className={"statelo-sorting " + sortClass[7]} onClick={this.handleSortTable} > Équipe B </th>
					<th id='hdr.9' className={"statelo-sorting " + sortClass[8]} onClick={this.handleSortTable} > Format </th>
					<th id='hdr.10' className={"statelo-sorting " + sortClass[10]} onClick={this.handleSortTable} > Validation </th>
					<th></th>
				</tr>
			</thead>

			{this.displayTable()}
			</table>

			</div>
			</div>
		);
	}

	displayTable() {
		if (this.state.scheduleData.length === 0) {
			return (
				<tbody>
					<tr><td colSpan="99">Aucun match</td></tr>
				</tbody>
			)
		} else {
			return (
				<tbody>
					{this.state.scheduleData.map(this.createTableRow)}
				</tbody>
			)
		}
	}

  createTableRow(sm, smIdx) {
  	var trClass = "stateloListItemPointer ";
		const smId = sm._id;
    return (
      <tr key={'sm.' + smIdx} onDoubleClick={this.handleAddEditScheduledMatchClick.bind(this, smId)} className={trClass}>
				<td><input name={'edit.' + smIdx} type="button" onClick={this.handleAddEditScheduledMatchClick.bind(this, smId)} value="Éditer"/></td>
				{sm.map(this.createDataCell.bind(this, smIdx))}
				<td><input name={'del.' + smIdx} type="button" onClick={this.handleDeleteScheduledMatchClick.bind(this, smId)} value="Supprimer"/></td>
      </tr>
    );
  }

	createDataCell(smIdx, dataCell, dataCellIdx) {
  	// Validation status translation
		if (dataCellIdx >= cstValidStatusColIdx) {
	  	cstSsValidationTranslation.forEach(ssvt => {
	  		if (dataCell === ssvt.en) {
	  			dataCell = ssvt.fr;
	  		}
	  	});
		}

		if (dataCellIdx === cstGoogleMapColIdx) {
			return (
				<td key={"tdcell." + dataCellIdx}> <a href={dataCell} target="blank"><i className="fa fa-map-o"></i></a> </td>
			);
		} else {
			return (
				<td key={"tdcell." + dataCellIdx}> {dataCell} </td>
			);
		}
	}

	handleAddEditScheduledMatchClick(smIdOrNew) {
	  let { modalScheduledMatch, scheduledMatchesMap } = this.state;

	  console.log("handleAddEditScheduledMatchClick")
	  console.log(smIdOrNew)
	  console.log(this.props.season.handicapType, this.props.season.handicapMax)
	  console.log(modalScheduledMatch)
/*
	  HERE
	  "Je dois utiliser le season.handicapType et le season.handicapMax pour initialiser la modale"
	  FAIT "Je dois aussi utiliser HandicapTypeSelect pour le handicapType select dans la modale"
	  "Et m'arranger pour pouvoir le changer dans la gestion des handicap dans la feuille de pointages"
*/

	  // NEW
	  if (smIdOrNew === "NEW SM") {

	    const newModal = {
	      ...modalScheduledMatch,
	      _id: '0',
	      ssIdx: this.state.ssIdxNext,
	      dateScheduled: null,
	      datePlayed: null,
	      week: 1,
	      locationId: '0',
	      subSeasonId: '0',
	      team1Id: '0',
	      team2Id: '0',
	      scoresheetFormatId: '0',
	      handicapType: this.props.season.handicapType,
	      handicapMax: this.props.season.handicapMax,
	      validation: {
	        teamA: { edited: false, validated: false },
	        teamB: { edited: false, validated: false },
	        validationStatusTxt: "None"
	      }
	    };

	    this.setState({
	      modalScheduledMatch: newModal,
	      showSeasonScheduledMatchModal: true
	    });
	    return;
	  }

	  // EDIT
	  const sm = scheduledMatchesMap[smIdOrNew];
	  if (!sm) {
	    console.warn("Scheduled match not found for id:", smIdOrNew);
	    return;
	  }

	  const modalToEdit = {
	    ...modalScheduledMatch,
	    _id: sm._id,
	    dateScheduled: sm.dateScheduled
	      ? moment(sm.dateScheduled).local().format("YYYY-MM-DD")
	      : '',
	    datePlayed: sm.datePlayed
	      ? moment(sm.datePlayed).local().format("YYYY-MM-DD")
	      : '',
	    ssIdx: sm.ssIdx,
	    week: sm.week,
	    seasonId: sm.seasonId,
	    subSeasonId: sm.subSeasonId,
	    locationId: sm.locationId,
	    team1Id: sm.team1Id,
	    team2Id: sm.team2Id,
	    scoresheetFormatId: sm.scoresheetFormatId,
	    handicapType: sm.handicapType ?? null,
	    handicapMax: sm.handicapMax ?? null,
	    validation: {
	      ...modalScheduledMatch.validation,
	      ...sm.validation       // garde edited / validated si tu les as en DB
	    }
	  };

	  this.setState({
	    modalScheduledMatch: modalToEdit,
	    showSeasonScheduledMatchModal: true
	  });
	}

	handleDeleteScheduledMatchClick(smId) {
	  const { scheduledMatchesMap } = this.state;
	  const sm = scheduledMatchesMap[smId];

	  if (!sm) {
	    console.warn("Scheduled match not found for delete, id:", smId);
	    return;
	  }

	  const dateScheduled = sm.dateScheduled
	    ? moment(sm.dateScheduled).local().format("YYYY-MM-DD")
	    : "";

	  const confirmAns = window.confirm(
	    "Voulez-vous vraiment supprimer le match suivant:\n" +
	      "Date du match: " + dateScheduled + "\n" +
	      "Lieu: " + (sm.locationName || "") + "\n" +
	      "Programme: " + (sm.week || "") + "\n" +
	      "Équipe 1: " + (sm.team1Name || "") + "\n" +
	      "Équipe 2: " + (sm.team2Name || "")
	  );

	  if (!confirmAns) return;

	  Axios.delete('/api/scoresheets2/' + smId)
	    .then(() => {
	      this.reloadData();
	    })
	    .catch((error) => {
	      console.log(error);
	    });
	}

	handleSortTable(e) {
		var colIdx = parseInt(e.target.id.split(".")[1], 10);
		var sortOrder = this.state.sortParams.sortOrder;
		var sortFieldIdx = this.state.sortParams.sortFieldIdx;

		// Toggle sort order
		if (sortFieldIdx === colIdx) {
			if (sortOrder === 'desc') {
				sortOrder = 'asc';
			} else {
				sortOrder = 'desc';
			}
		} else {
			sortOrder = cstDefaultSortOrder[colIdx];
		}

		var sortClass = [];
		for(var i = 0; i < (TABLE_NBCOL - 1); i++) {
			sortClass[i] = '';
		}
		sortClass[colIdx] = "statelo-sorting_" + sortOrder;

		var sortParams = {
			sortFieldIdx: colIdx,
			sortOrder: sortOrder,
			sortClass: sortClass
		};

		this.sortscheduleData(this.state.scheduleData, sortParams);
	}

	handleModalCancel() {
		this.setState({ 
			showSeasonScheduledMatchModal: false
		});
	}

	displaySpinner() {
		return (
  		<div className="sk-three-bounce">
    		<div className="sk-child sk-bounce1"></div>
    		<div className="sk-child sk-bounce2"></div>
    		<div className="sk-child sk-bounce3"></div>
  		</div>
  	);
	}

	// isNumeric function in javascript
	isNumeric(n) {
  	return !isNaN(parseFloat(n)) && isFinite(n);
	}

}

export default withRouter(SeasonSchedule);
